import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { gtmPageView } from '@/lib/gtm';
// import { trackEvent } from './useAnalytics'; // BACKEND DISABLED - using local version

/**
 * Hook to track SPA route changes for Google Analytics
 * Fires on initial mount and every route change
 */
export const useSPAPageTracking = () => {
  const location = useLocation();
  const previousPath = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Skip if it's the same path (prevents duplicate events)
    if (previousPath.current === currentPath) {
      return;
    }

    previousPath.current = currentPath;

    // Get page title
    const pageTitle = document.title;

    // Track in GTM
    gtmPageView(currentPath, pageTitle);

    // BACKEND DISABLED - Internal analytics commented out
    // trackEvent('page_view', {
    //   page: currentPath,
    //   page_title: pageTitle,
    // });

    console.info('[Analytics] Page view tracked (GTM only):', { path: currentPath, title: pageTitle });
  }, [location.pathname]);
};
